import React from "react";
import "./Feedback.css";
// import Modal from "react-bootstrap/Modal";
import FeedbackModel from "./../../model/FeedbackModel"


// You can import images here if needed
// import feedbackImg from "../../assets/img/feedback-img.svg";
// import feedbackImg from "../../assets/img/feedback.webp"

export default class FeedbackPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      email: "",
      feedback: "",
      rating: 0,
      submitted: false,
      feedbacks: [],

    };
    // Create an instance of the FeedbackModel
    this.feedbackModel = new FeedbackModel();

    // Binding methods
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleRatingChange = this.handleRatingChange.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  async componentDidMount() {
    try {
      const response = await this.feedbackModel.GetFeedback();
      console.log("Fetched feedback:", response); // Add this log to check the data structure

      if (response && response.user_feedback) {
        const { name, email, feedback, rating } = response.user_feedback;
        this.setState({
          name: name,
          email: email,
          feedback: feedback,
          rating: parseInt(rating, 10),  // Convert rating to number if needed
        });
      }
    } catch (error) {
      console.error("Error fetching feedback:", error);
    }
  }


  handleSubmit(e) {
    e.preventDefault();

    const { name, email, feedback, rating } = this.state;

    // Check if required fields are filled
    if (!name || !email || !feedback || rating === 0) {
      alert("Please fill out all required fields");
      return;
    }

    // Submit the feedback using FeedbackModel
    this.feedbackModel
      .SubmitFeedback(name, email, feedback, rating)
      .then((response) => {
        this.setState({ submitted: true });

        // Fetch the updated feedback list
        this.feedbackModel.GetFeedback().then((updatedFeedbacks) => {
          this.setState({ feedbacks: updatedFeedbacks });
        });
      })
      .catch((error) => {
        console.error("Error submitting feedback: ", error);
      });
  }

  handleInputChange(e) {
    const { id, value } = e.target;
    this.setState({ [id]: value });
  }

  handleRatingChange(value) {
    this.setState({ rating: value });
  }

  handleReset() {
    this.setState({ submitted: false });
    this.feedbackModel.GetFeedback().then((updatedFeedbacks) => {
      this.setState({ feedbacks: updatedFeedbacks });
    });
  }

  render() {
    const { name, email, feedback, rating, submitted } = this.state;
    return (
      <div className= "content">
        {submitted ? (
          <div className="thank-you-message">
            <h3>Thank you for your feedback!</h3>
            <h2 onClick={this.handleReset}>View and update Feedback</h2> 
          </div>
        ) : (
          <form id="feedback-form" onSubmit={this.handleSubmit}>
            <div className="form-group">
              <label htmlFor="name" className="form-label">Name</label>
              <input
                type="text"
                className="form-control" 
                id="name"
                value={name}
                onChange={this.handleInputChange}
                placeholder="Enter your name"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email" className="form-label">Email</label>
              <input
                type="email"
                className="form-control" 
                id="email"
                value={email}
                onChange={this.handleInputChange}
                placeholder="Enter your email"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="feedback" className="form-label">Feedback</label>
              <textarea
                id="feedback"
                className="form-control" 
                value={feedback}
                onChange={this.handleInputChange}
                placeholder="Enter your feedback"
                rows="5"
                required
              />
            </div>

            <div className="form-group tc">
              <label className="form-label">Rating</label>
              <div className="rating">
                {[1, 2, 3, 4, 5].map((value) => (
                  <span
                    key={value}
                    className={`star ${value <= rating ? "selected" : ""}`}
                    onClick={() => this.handleRatingChange(value)}
                  >
                    ★
                  </span>
                ))}
              </div>
            </div>

            {/* <button type="submit" className="feedback">
              Submit Feedback
            </button> */}
            <h2 onClick={this.handleSubmit}>Submit</h2>
            
          </form>
        )}
      </div>
      
    );
  }
  // <div className="feedback-list">
  //         <h3>Existing Feedback</h3>
  //         <ul>
  //           {feedbacks.map((feedback, index) => (
  //             <li key={index}>
  //               <p><strong>{feedback.name}</strong> ({feedback.email})</p>
  //               <p>{feedback.feedback}</p>
  //               <p>Rating: {feedback.rating} ★</p>
  //             </li>
  //           ))}
  //         </ul>
  //       </div>
}